module.exports = __webpack_public_path__ + "static/media/1920-service-2-1-min.3e8b026f.jpg";